import apiCall from './call'

const model = 'metrics'

const state = {
  all: {}
}

const actions = {
  getMetric ({ commit }, data) {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + data.metric, qs: data.qs })
        .then(response => {
          commit('setMetric', {
            metric: data.metric,
            data: response.data
          })
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const mutations = {
  setMetric (state, metricObj) {
    state.all = { ...state.all, [metricObj.metric]: metricObj.data }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/metrics.js